module.exports = __webpack_public_path__ + "imgs/blaze.9e104850fee0c80cc687ce9ce4ad3e76.jpg";